<template>
  <div class="vertical-center-dialog">
    <el-dialog
      :title="isEdit ? '编辑计划' : '添加计划'"
      :visible.sync="dialogVisible"
      width="50%"
      :close-on-click-modal="false"
      :append-to-body="false"
      :modal-append-to-body="false"
      @close="handleClose"
      custom-class="plan-dialog-width-limit">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="100px"
        size="small">
        <el-form-item label="计划名称" prop="plan_name">
          <el-input
            v-model="form.plan_name"
            placeholder="请输入计划名称"
            style="width: 100%">
          </el-input>
        </el-form-item>
        
        <el-form-item label="计划内容" prop="plan_info">
          <el-input
            v-model="form.plan_info"
            type="textarea"
            :rows="6"
            placeholder="请输入计划内容"
            style="width: 100%">
          </el-input>
        </el-form-item>
        
        <el-form-item label="预计开始时间">
          <el-date-picker
            v-model="form.scheduled_start_time"
            type="date"
            placeholder="选择预计开始时间"
            value-format="yyyy-MM-dd"
            style="width: 100%">
          </el-date-picker>
        </el-form-item>
        
        <el-form-item label="预计完成时间">
          <el-date-picker
            v-model="form.scheduled_end_time"
            type="date"
            placeholder="选择预计完成时间"
            value-format="yyyy-MM-dd"
            style="width: 100%">
          </el-date-picker>
        </el-form-item>
      </el-form>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { addPlan, updatePlan } from '@/api/plan'

export default {
  name: 'PlanDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    plan: {
      type: Object,
      default: () => ({})
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      form: {
        plan_name: '',
        plan_info: '',
        scheduled_start_time: '',
        scheduled_end_time: ''
      },
      rules: {
        plan_name: [
          { required: true, message: '请输入计划名称', trigger: 'blur' },
          { min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }
        ],
        plan_info: [
          { required: true, message: '请输入计划内容', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  watch: {
    visible(val) {
      if (val && this.isEdit) {
        this.form = {
          plan_name: this.plan.plan_name,
          plan_info: this.plan.plan_info,
          scheduled_start_time: this.plan.scheduled_start_time || '',
          scheduled_end_time: this.plan.scheduled_end_time || ''
        }
      }
    }
  },
  methods: {
    handleClose() {
      this.dialogVisible = false
      this.$refs.form?.resetFields()
      this.form = {
        plan_name: '',
        plan_info: '',
        scheduled_start_time: '',
        scheduled_end_time: ''
      }
    },
    async handleSubmit() {
      try {
        await this.$refs.form.validate()
        
        this.loading = true
        if (this.isEdit) {
          await updatePlan(this.plan.plan_code, this.form)
          this.$message.success('更新成功')
        } else {
          await addPlan(this.form)
          this.$message.success('添加成功')
        }
        
        this.$emit('success')
        this.handleClose()
      } catch (error) {
        console.error(error)
        this.$message.error(error.message || '操作失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-footer {
  text-align: right;
}
</style>

<style lang="scss">
// 全局样式 - 限制对话框最大宽度
.el-dialog__wrapper .plan-dialog-width-limit {
  width: 50% !important;
  max-width: 800px !important;
  margin: 0 auto !important;
}

.plan-dialog-width-limit.el-dialog {
  width: 100% !important;
}
</style>
 